var _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Play Button Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Play Button Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26,20 46,32 26,44",
    fill: "#ffffff",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoManager);
export default __webpack_public_path__ + "static/media/video_manager.b6f151ca0674450793ed1e3abe420858.svg";
export { ForwardRef as ReactComponent };